import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import * as React from 'react';

interface DocumentsLinkButtonProps {
  documentsUrl: string;
  isLoading?: boolean
  renewal?: boolean;
  isBlock?: boolean;
}

export const DocumentsLinkButton = ({ documentsUrl, isLoading = false, renewal = false, isBlock = false }: DocumentsLinkButtonProps) => {
  return (
    <>
      <Link to={documentsUrl}>
        <Button
          bsStyle={'primary'}
          disabled={isLoading}
          block={isBlock}
          className={isBlock ?  'secondary-button' : 'medium-width secondary-button'}>
          DOCUMENTS
        </Button>
      </Link>
    </>
  );
}
